<template>
    <main id="dashboard" class="full">
        <section class="full block heroImage" v-if="heroImg" :style="{ backgroundImage: 'url(' + heroImg + ')' }"></section>
        <div class="row">
            <CatalogueWidget :item-list="itemList" :swiper-option="swiperOption" />
            <PlanoWidget v-if="hasPlanobuilderRights" :swiper-option="swiperOption" />
            <StarredItemsWidget v-if="itemsStar.length" :item-list="itemsStar" />
            <MyOrdersWidget v-if="hasOrderRights" />
            <ForecastWidget v-if="hasForecastAccess" />

            <transition-group name="fade">
                <duplicate
                    :key="showModal"
                    :show="showModal"
                    :currentPlanoCampaign="currentPlanoCampaign"
                    :currentPlanoZone="currentPlanoZone"
                    :currentPlanoId="currentPlanoId"
                    :currentPlanoName="currentPlanoName"
                    @close="showModal = false;"
                ></duplicate>
                <Comment :key="showModalComment" v-if="showModalComment" @closeModal="modalClose($event);"></Comment>
            </transition-group>
        </div>
    </main>
</template>
<script>
import Globals from "../globals.js";
import { mapGetters } from "vuex";

import Duplicate from "../planos/duplicate.vue";
import Comment from "../modal/modalComment.vue";
import Modal from "../planos/modal/Modal";
import planoList from "../planoList/planoList";
import ComponentListItem from "../ComponentListItem/ComponentListItem";
import cacheService from "@/services/cache";
import { FUNCTIONALITY as forecastFunctionality } from "@/components/forecasts/constants";
import BaseWidget from "@/components/dashboard/BaseWidget";
import MyOrdersWidget from "@/components/dashboard/widgets/MyOrdersWidget";
import Template from "@/plano/template";
import OrderList from "@/components/orders/order-common/order-list";
import PlanoWidget from "@/components/dashboard/widgets/PlanoWidget";
import CatalogueWidget from "@/components/dashboard/widgets/CatalogueWidget";
import StarredItemsWidget from "@/components/dashboard/widgets/StarredItemsWidget";
import ForecastWidget from "@/components/dashboard/widgets/ForecastWidget";
import { PROFILES } from "@/plugins/AccessUserPlugin";

export default {
    components: {
        ForecastWidget,
        StarredItemsWidget,
        CatalogueWidget,
        OrderList,
        Template,
        duplicate: Duplicate,
        Comment,
        Modal,
        planoList,
        ComponentListItem,
        BaseWidget,
        MyOrdersWidget,
        PlanoWidget
    },
    data: () => ({
        colors: cacheService.getBrandColors(),
        swiperOption: {
            // autoplay: 3000,
            direction: "horizontal",
            loop: true,
            grabCursor: true,
            setWrapperSize: true,
            autoHeight: false,
            pagination: ".swiper-pagination",
            paginationClickable: true,
            mousewheelControl: true,
            observeParents: true,
            // if you need use plugins in the swiper, you can config in here like this
            debugger: true,
            // swiper callbacks
            onTransitionStart(swiper) {}
        },
        dataAction: "",
        rollOver: false,
        role: {},
        langSelected: "",
        langue: "",
        message: "JEAN",
        searchResults: [],
        rem3rchUser: {},
        user: {},
        displayIndex: null,
        showModal: false,
        planoToDuplicate: null,
        currentPlanoCampaign: null,
        currentPlanoZone: null,
        currentPlanoId: null,
        currentPlanoName: null,
        idPlano: "",
        showModalComment: false,
        planoList: [],
        itemList: [],
        itemsStar: [],
        selectedCampaign: cacheService.getCurrentCampaignId()
    }),
    methods: {
        /**
         * @arguments   {int} nbItems
         * @description this method is a façade
         * of this.getItems for get N items from last
         * only add - to number of items
         */
        getNLastesItems(nbItems) {
            let negativeNbItems = nbItems;
            return this.getItems(negativeNbItems);
        },
        modalClose(close) {
            this.showModalComment = close;
        }
    },
    computed: {
        ...mapGetters({
            getAllItems: "items/getAllItems",
            getItems: "items/getItems",
            getItemsLength: "items/getItemsLength",
            getBrandColor: "brand/getLinksColor",
            getBrand: "brand/getBrand"
        }),
        ...mapGetters("planos/search/", {
            getAllResults: "getAllResults",
            getResults: "getResults"
        }),
        hasOrderRights() {
            return this.hasAccessRead("orders_manager");
        },
        hasPlanobuilderRights() {
            return this.hasAccessRead("plano_builder");
        },
        hasForecastAccess() {
            return (
                this.hasAccessByProfile(PROFILES.ZONE_FORECASTER) ||
                this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR) ||
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER)
            );
        },
        heroImg() {
            return this.getBrand.heroImg ? Globals.getBaseUrl() + this.getBrand.imgPath + this.getBrand.heroImg : false;
        }
    },
    created() {
        this.role = cacheService.getRem3rchUser();

        this.$store.dispatch("items/populate").then(() => {
            let items = this.getNLastesItems(6);
            let test = items.slice(0, 6);
            test.sort(function(a, b) {
                let date1 = new Date(a.modifiedDate);
                let date2 = new Date(b.modifiedDate);
                return date2.getTime() - date1.getTime();
            });
            this.itemList = test;
            this.itemsStar = items.filter(value => {
                return value.isStar === true;
            });
        });

        this.rem3rchUser = cacheService.getRem3rchUser();
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.heroImage {
    margin: 25px 0px;
    @extend %primary-border;
    height: 300px;
    line-height: 300px;
    background-image: url("../../assets/Maybelline-visual.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}

@media only screen and (max-width: 767px) {
    #dashboard {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?19db57ae